import { AbstractControl, ValidationErrors } from "@angular/forms";

export const integerValidator = (control: AbstractControl): ValidationErrors | null => {
  const integer = control.value;
  return /^[0-9]*$/.test(integer) ? null : { integer };
};
